import React from "react";
import { Link } from "react-router-dom";
import { FaYoutube, FaInstagram } from "react-icons/fa";
import Newsletter from "./Newsletter";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-gray-200 py-10">
      <div className="container mx-auto px-6 md:px-12">
        {/* Newsletter Signup */}
        <Newsletter />
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Logo + Description */}
          <div>
            <div className="flex items-center space-x-2">
              <img
                src="/logo.svg" // replace with your logo path
                alt="VEDA"
                className="h-10"
              />
            </div>
            <p className="mt-3 text-sm text-gray-500 max-w-xs">
              A universe of fun and learning from Indian mythology.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-3">{t('footer.explore')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <Link to="/products" className="hover:text-red-500">
                  {t('header.toys')}
                </Link>
              </li>
              <li>
                <Link to="/games" className="hover:text-red-500">
                  {t('header.games')}
                </Link>
              </li>
              <li>
                <Link to="/puzzles" className="hover:text-red-500">
                  {t('header.puzzles')}
                </Link>
              </li>
              <li>
                <Link to="/videos" className="hover:text-red-500">
                  {t('header.videos')}
                </Link>
              </li>
            </ul>
          </div>

          {/* About */}
          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-3">{t('footer.about')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <Link to="/about" className="hover:text-red-500">
                  {t('footer.aboutUs')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-red-500">
                  {t('footer.contactUs')}
                </Link>
              </li>
              <li>
                <Link to="/faqs" className="hover:text-red-500">
                  {t('footer.faqs')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-3">{t('footer.policies')}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <Link to="/cancellation-refund-policy" className="hover:text-red-500">
                  {t('footer.cancellationRefund')}
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions-policy" className="hover:text-red-500">
                  {t('footer.termsConditions')}
                </Link>
              </li>
              <li>
                <Link to="/shipping-delivery-policy" className="hover:text-red-500">
                  {t('footer.shippingDelivery')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-red-500">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-3">
              {t('footer.followUs')}
            </h3>
            <div className="flex space-x-4 text-gray-500">      
              <a
                href="https://www.instagram.com/vedaepictales?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-5red05"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="https://youtube.com/@vedaepictales?si=4SqmUNkrMpHqj4lb"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-red-500"
              >
                <FaYoutube size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="mt-8 border-t border-gray-200 pt-6 text-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} VEDA. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;